module.exports = {
  title: "Programming (ප්‍රෝග්‍රෑමිං) සරලව",
  slug: "programming",
  description:
    "මෙය Python programming භාෂාව යොදාගෙන programming වල මූලික සිද්ධාන්ත සමග අවශ්‍ය කුසලතා වර්ධනය කරන course එකකි.",
  videos: [
    {
      id: 1,
      title: "හැඳින්වීම",
      link: "https://www.youtube.com/embed/sU5Nt9HfiAk",
    },
    {
      id: 2,
      title:
        "Android Phone වලින් Course එක ඉගෙනීම (pydroid) සහ දෙවෙනි හැඳින්වීම",
      link: "https://www.youtube.com/embed/pawuPNvFYRs",
    },
    {
      id: 3,
      title: "1 පාඩම: Installation සහ hello world",
      link: "https://www.youtube.com/embed/IuO3gMw6cps",
    },
    {
      id: 4,
      title: "2 පාඩම: Programming: ප්‍රථම පියවර - PART 1",
      link: "https://www.youtube.com/embed/uypc4AxQS_M",
    },
    {
      id: 5,
      title: "2 පාඩම: Programming: ප්‍රථම පියවර - PART 2",
      link: "https://www.youtube.com/embed/rAGi5P0jXJQ",
      codeFiles:
        "https://drive.google.com/drive/folders/12-Rna_u8PYZl7_2oY6jmKjeFWrqvP88o",
    },
    {
      id: 6,
      title: "2 පාඩම: Programming: ප්‍රථම පියවර - PART 3",
      link: "https://www.youtube.com/embed/0ApJu_RYgXA",
    },
    {
      id: 7,
      title: "3 පාඩම: අංක ගණිතය, variables(විචල්‍ය) සහ types - PART 1",
      link: "https://www.youtube.com/embed/N4MWF5Rweq0",
    },
    {
      id: 8,
      title: "3 පාඩම: අංක ගණිතය, variables(විචල්‍ය) සහ types - PART 2",
      link: "https://www.youtube.com/embed/e3HO9Bh46qA",
      exercises:
        "https://drive.google.com/file/d/14qCwRWTWSyIMLbt4v6RxNmh88g-DehIU/view",
      solutions:
        "https://drive.google.com/file/d/1GPeUi0mVMh6HfBr3u68Q2TaY6-MMy_b5/view",
    },
    {
      id: 9,
      title: "4 පාඩම: Boolean variables, සහ if  else  conditions - PART 1",
      link: "https://www.youtube.com/embed/lodD-qIHJbs",
    },
    {
      id: 10,
      title: "4 පාඩම: Boolean variables, සහ if  else  conditions - PART 2",
      link: "https://www.youtube.com/embed/lZgTUMgSnvs",
      exercises:
        "https://drive.google.com/file/d/1wtDOIhfwzdFeV_ecxuH-5hkHrSf2MST5/view",
      solutions:
        "https://drive.google.com/file/d/1mTjJddLSoeDKn25UtC2Q75E_Uw3n2eFB/view",
    },
    {
      id: 11,
      title: "Debugging පාඩම: 1",
      link: "https://www.youtube.com/embed/JANfms4i-Ao",
      exercises:
        "https://drive.google.com/file/d/1luy4vN4fqAQKGWX8LPEzxS-6Koq-RKF-/view",
      solutions:
        "https://drive.google.com/file/d/1R5ZfWf2hP_mJq2DHUkgIMA1zbxZFtoql/view",
    },
    {
      id: 12,
      title: "5 පාඩම: List",
      link: "https://www.youtube.com/embed/YQlH3Mrwx-Q",
      exercises:
        "https://drive.google.com/file/d/1seKd1Um8SAdPpcv1JevaJCu9O6UeRySw/view",
      solutions:
        "https://drive.google.com/file/d/1RASYnA9PF5fdDDIH79zAUaAlE6ls8LmU/view",
    },
    {
      id: 13,
      title: "6 පාඩම: Loops (for සහ while loops) - PART 1",
      link: "https://www.youtube.com/embed/Z9nSRd-c2Ao",
    },
    {
      id: 14,
      title: "6 පාඩම: Loops (for සහ while loops) - PART 2",
      link: "https://www.youtube.com/embed/Sm6U3endSy0",
    },
    {
      id: 15,
      title: "6 පාඩම: Loops (for සහ while loops) - PART 3",
      link: "https://www.youtube.com/embed/liPQIDc1JRk",
      exercises:
        "https://drive.google.com/file/d/1UkXU4KAIujzHpCqQnJvhHaIaCpn--QmJ/view",
      solutions:
        "https://drive.google.com/file/d/1XCINQaENdYWb1tjyLAjIJwPYHn4DIct_/view",
    },
    {
      id: 16,
      title: "Debugging පාඩම: 2",
      description: "මෙහි video නැත. අභ්‍යාස වලින් මේ ටික ඉගෙනගමු",
      exercises:
        "https://drive.google.com/file/d/16I6epcyvY_E9wcQRG6ittRSqv1cuIxfx/view",
      solutions:
        "https://drive.google.com/file/d/1H-VmOxsfT9CArkWRUudXO3lgVsuWHS5g/view",
    },
    {
      id: 17,
      title: "7 පාඩම: loop ක්‍රම සහ functions define කිරීම - PART 1",
      link: "https://www.youtube.com/embed/EO1jGQOsl-Y",
    },
    {
      id: 18,
      title: "7 පාඩම: loop ක්‍රම සහ functions define කිරීම - PART 2",
      link: "https://www.youtube.com/embed/ru-1cWaelVc",
      exercises:
        "https://drive.google.com/file/d/1LHRMhF9siB_FqDJEKzkiVfCwvpt6PVSZ/view",
      solutions:
        "https://drive.google.com/file/d/1Hp57E6BwYKBKkFrPsqvXl_H1n3Mf4Rvg/view",
    },
    {
      id: 19,
      title: "8 පාඩම: functions ගැන තවත්",
      link: "https://www.youtube.com/embed/dHuyHzQ3poI",
      exercises:
        "https://drive.google.com/file/d/1mbzqpUdYsWWpGzqsNynGR409F7V7_5lX/view",
      solutions:
        "https://drive.google.com/file/d/1547vGJCFzCp5OeBHJajbEgnnb4_iEy8w/view",
    },
    {
      id: 20,
      title: "9 පාඩම: Collatz conjecture: අධ්‍යනයක්",
      link: "https://www.youtube.com/embed/Qoe_EbfPB0Y",
    },
    {
      id: 21,
      title: "Project 1",
      description:
        "මෙහි video නැත. අභ්‍යාස කිරීමෙන් අපි ටක් ටික් ටුක් (tic tac toe) සෙල්ලම කිරීමට code එකක් හදමු.",
      exercises:
        "https://drive.google.com/file/d/1AEL5Zej1Gj6Uh4e5jT6tvZVKWCJtt_J4/view",
      solutions:
        "https://drive.google.com/file/d/1DmZtgUm3ULGebbS620R_NE5aXq12sfWT/view",
    },
    {
      id: 22,
      title: "Project රටා",
      link: "https://www.youtube.com/embed/rLTMHRVmjCA",
    },
  ],
}
